import request from '@/utils/request'
import { v2Host } from '@/config/host'
import _ from 'lodash'

export function deleteMaterial(data) {
  const id = data.id
  data = _.omit(data, ['id'])
  return request({
    url: `${v2Host}/res_store/delete?id=${id}`,
    method: 'post',
    data: data
  })
}
